<template>
  <div class="section center-vertical">
    <div class="section-horizontal mt-5 mb-5 nucleo12scroll1">
      <div class="horizontal-content">
        <div class="horizontal horizontal-1">
          <div class="titulo animado">
            Dados sobre a imunização da população privada de liberdade e a
            população geral.
          </div>
          <a
            class="link-fonte"
            href="http://www.global.org.br/wp-content/uploads/2021/05/Balanco-da-Politica-Brasileira-de-Vacinas-2.pdf"
            target="_blank"
            ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
          >
        </div>
        <div class="seta mx-5">
          <!-- <i class="bi bi-chevron-double-right"></i> -->
        </div>
        <div class="horizontal horizontal-2">
          <div class="text">
            De acordo com “O Balanço da Política Brasileira de Vacina” do
            Observatório Direitos Humanos Crise e Covid-19 até abril de 2021
          </div>
          <div class="numeracao">
            13,<NumberCounter :from="1" :to="96" :duration="2"></NumberCounter>
            %
          </div>
          <div class="text">
            da população geral recebeu a primeira dose da vacina, enquanto isso
            somente
          </div>
          <div class="numeracao">
            0,0<NumberCounter :from="1" :to="8" :duration="2"></NumberCounter>
            %
          </div>
          <div class="text">da população privada de liberdade e</div>
          <div class="numeracao">
            10,<NumberCounter :from="1" :to="47" :duration="2"></NumberCounter>
            %
          </div>
          <div class="text">
            entre os servidores dessas instituições tomaram a primeira dose.
          </div>
        </div>
        <!-- <div class="line"></div>
        <div class="horizontal horizontal-3">
          <div class="text">Dezembro / 2021</div>
          <br />
          <div class="text">
            O monitoramento indicava que a realização de testes para detecção de
            Covid-19 desacelerava conforme avançava a vacinação, com uma
            variação entre as quinzenas, tendo
          </div>
          <div class="numeracao">
            0,<NumberCounter
              :from="1"
              :to="8"
              :duration="1"
              isZero
            ></NumberCounter
            >%
          </div>
          <div class="text">
            da população privada de liberdade com a 1° dose e
          </div>
          <div class="numeracao">
            10,<NumberCounter
              :from="1"
              :to="47"
              :duration="1"
              isZero
            ></NumberCounter
            >%
          </div>
          <div class="text">entre servidores dessas instituições</div>
        </div> -->
      </div>
    </div>
    <div class="arraste-section" @click="scrollRight">
      Arraste para o lado <i class="bi bi-chevron-double-right seta"></i>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    scrollRight() {
      let content = document.querySelector(".nucleo12scroll1");
      content.scrollLeft += 300;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-red {
  margin-top: 60px;
  background-color: #d01c1f;
  color: white;
  font-family: Roboto Mono;
  padding: 2px 2px 0px 2px;
  font-size: 1.5rem;
  font-weight: 300;
}

.arraste-section {
  display: none;
}

.horizontal-content {
  color: #d01c1f;
  font-size: 1.1rem;
  font-family: Roboto Condensed;
  font-weight: 300;
  padding: 30px;
  display: flex;
  width: fit-content;
}

.seta {
  color: #626262;
}

.line {
  width: 1px;
  background-color: #626262a2;
  height: 400px;
  margin: 0 55px;
}

.horizontal {
  position: relative;
  .data {
    font-size: 3rem;
    font-family: Roboto Mono;
    font-weight: 100;
  }
  .titulo {
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: 300;
    font-size: 1.8rem;
    line-height: 1.7rem;
    color: #d01c1f;
    margin-bottom: 30px;
    width: 260px;

    &.animado {
      font-family: Roboto Mono;
      font-size: 2rem;
      line-height: 2rem;
      font-weight: 100;
    }
  }
  .text {
    width: 260px;
    line-height: 1.1rem;

    &.big {
      font-size: 3rem;
      line-height: 3.1rem;
      font-family: Roboto Mono;
      color: #626262;
      font-weight: 100;
    }
  }
  img {
    width: 260px;
  }
  .numeracao {
    font-family: Roboto Mono;
    font-weight: 100;
    font-size: 3.3rem;
  }
}

*::-webkit-scrollbar {
  width: 3px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: #e4e4e4;
}

*::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}

@media screen and (max-width: 480px) {
  .arraste-section {
    display: block;
  }
}
</style>